import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import type { Publisher } from '@ilteducation/content-ref-data-types';
import PublisherLogoUploader from '../../components/PublisherLogoUploader.vue';

type Props = {
  id: string;
  title: string;
  item?: Publisher;
  isCreate?: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    id: null,
    title: null,
    item: null,
    isCreate: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  title: string;
  item?: Publisher;
  isCreate?: boolean;
}


const bookField = ref([
  { source: 'id', link: 'edit', sortable: false },
  {
    source: 'title',
    sortable: true,
  },
  {
    source: 'isbn',
    sortable: true,
  },
  {
    source: 'publisher.name',
    sortable: true,
  },
  {
    source: 'publisher.id',
    sortable: true,
  },
]);
const benField = ref([
  { source: 'id', link: 'edit', sortable: false },
  {
    source: 'title',
    sortable: true,
  },
  {
    source: 'isbn',
    sortable: true,
  },
  {
    source: 'royaltyBeneficiaries.name',
    sortable: true,
  },
  {
    source: 'royaltyBeneficiaries.id',
    sortable: true,
  },
]);

return { __sfc: true,props, bookField, benField, PublisherLogoUploader }
}

})